(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Must match the nav collapse transition in this section's <style> block.
  const CONDENSE_TRANSITION_MS = 200;
  // Deliberately longer than the transition — see beginCondenseAnimation(). Scroll
  // anchoring drifts for exactly as long as the header's height is changing, so a
  // guard equal to the transition finishes in a photo-finish with it (measured: 8ms
  // apart) and a trailing drift event lands after the guard expires, gets misread as
  // a real direction change, and toggles the header straight back. The margin makes
  // that ordering deterministic instead of a race.
  const CONDENSE_GUARD_MS = CONDENSE_TRANSITION_MS + 150;

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Scroll anchoring reacting to our own height change — not the user. Track the
      // position so direction is correct once we settle, but do not act on it.
      // See beginCondenseAnimation().
      if (this.condenseAnimating) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    /* Condensing runs BEFORE the headerIsAlwaysSticky early-returns below. In
       'always' mode the only class onScroll still toggles is scrolled-past-header,
       and that is added on scroll down AND scroll up — it encodes "have scrolled",
       not direction, so it cannot drive a reveal-on-scroll-up rule on its own. */
    condense() {
      if (this.header.classList.contains('header-condensed')) return;
      this.beginCondenseAnimation();
      this.header.classList.add('header-condensed');
      // The desktop menu is dropdown type: a disclosure left open while its pill
      // collapses would leave an orphaned panel floating under the header.
      this.closeMenuDisclosure();
    }

    expand() {
      if (!this.header.classList.contains('header-condensed')) return;
      this.beginCondenseAnimation();
      this.header.classList.remove('header-condensed');
    }

    /* The header is in flow (position: sticky), so collapsing the nav row makes the
       whole document shorter. The browser's scroll anchoring then compensates by
       nudging scrollY to keep the visible content still — and onScroll reads that
       nudge as the user reversing direction, so it toggles straight back. Measured:
       condense at scrollY 600 -> docHeight 7116->7107 -> scrollY 600->591 -> reads
       as "scroll up" -> expand -> scrollY 591->595 -> reads as "scroll down". It
       flip-flops every ~8ms and never settles.

       Those scroll events are self-inflicted, not the user's, so ignore direction
       until the height has settled and the drift with it. Guarded by the idempotence
       checks above, which keep a continuous scroll from re-arming this every frame.

       The guard must OUTLAST the transition rather than match it: the drift only
       happens while the height is changing, so it ends when the transition does, and
       a guard of the same length ties with it. */
    /* --header-height is what anything sticking below the header offsets itself from
       (e.g. .about-atp-middle.is-sticky). Dawn only sets it on load and on breakpoint
       change, which was fine for a fixed-height header — but ours now changes height,
       and a stale value would leave the column either tucked under the header or
       floating ~70px below it. Track the real height for the length of the transition
       so the offset follows the collapse frame by frame.

       This only moves sticky tops; it changes no element's height, so it cannot feed
       back into the scroll-anchoring loop described above. */
    syncHeaderHeightWhileAnimating() {
      cancelAnimationFrame(this.heightSyncFrame);
      const started = performance.now();
      const step = () => {
        this.setHeaderHeight();
        if (performance.now() - started < CONDENSE_GUARD_MS) {
          this.heightSyncFrame = requestAnimationFrame(step);
        }
      };
      this.heightSyncFrame = requestAnimationFrame(step);
    }

    beginCondenseAnimation() {
      this.condenseAnimating = true;
      this.syncHeaderHeightWhileAnimating();
      clearTimeout(this.condenseTimer);
      this.condenseTimer = setTimeout(() => {
        this.condenseAnimating = false;
        // Resync so the next real scroll is measured from where anchoring left us,
        // not from where the user was before the drift.
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      }, CONDENSE_GUARD_MS);
    }

    hide() {
      this.condense();
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.expand();
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.expand();
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
